if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
          this.updateBnplContent();
          this.initExpressCheckoutWidget();

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      this.modalContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
        variantSelect.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }

    updateBnplContent() {
      if (!this.modalContent) return;

      const geoAllowed = Array.isArray(window.__SA_GEO_ALLOWED)
        ? window.__SA_GEO_ALLOWED
        : ['AE', 'SA', 'KW', 'OM', 'QA', 'BH', 'EG'];
      const bnplAllowed = Array.isArray(window.__SA_BNPL_ALLOWED)
        ? window.__SA_BNPL_ALLOWED
        : ['AE', 'SA', 'EG'];

      const applyVisibility = () => {
        const country = window.__saGeoCountry || '';
        const showExpress = geoAllowed.includes(country);
        const showBnpl = bnplAllowed.includes(country);

        this.modalContent.querySelectorAll('[data-bnpl-wrapper]').forEach((wrapper) => {
          const bnplOffer = wrapper.querySelector('[data-bnpl-offer]');
          const expressOffer = wrapper.querySelector('[data-express-offer]');

          if (bnplOffer) bnplOffer.style.display = showBnpl ? 'flex' : 'none';
          if (expressOffer) expressOffer.style.display = showExpress ? 'flex' : 'none';

          const shouldShow =
            (showExpress && expressOffer) || (showBnpl && bnplOffer);
          wrapper.style.display = shouldShow ? 'block' : 'none';
        });
      };

      applyVisibility();
      requestAnimationFrame(applyVisibility);
      setTimeout(applyVisibility, 500);
      setTimeout(applyVisibility, 1500);
    }

    initExpressCheckoutWidget() {
      if (window.__SELLABROAD_DISABLED) return;
      if (!this.modalContent) return;
      
      const modalContent = this.modalContent;
      const widget = this.modalContent.querySelector('[data-sellabroad-express-checkout]');
      if (!widget) return;

      const scopeReinitializeTo = (container) => {
        const removed = [];
        document.querySelectorAll('[data-sellabroad-express-checkout]').forEach((w) => {
          if (!container.contains(w)) {
            w.dataset.saTempRemoved = '1';
            w.removeAttribute('data-sellabroad-express-checkout');
            removed.push(w);
          }
        });

        try {
          if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) {
            window.SellabroadExpressCheckout.reinitialize();
          }
        } finally {
          setTimeout(() => {
            removed.forEach((w) => {
              if (w.dataset.saTempRemoved === '1') {
                w.setAttribute('data-sellabroad-express-checkout', '');
                delete w.dataset.saTempRemoved;
              }
            });
          }, 50);
        }
      };
      
      // Check if widget script is already loaded
      if (window.SellabroadExpressCheckout && window.SellabroadExpressCheckout.reinitialize) {
        // Scope reinitialize() to this modal content to avoid initializing widgets elsewhere on the page
        scopeReinitializeTo(modalContent);
        return;
      }
      
      // Widget script not loaded yet, wait for geo country and load script
      function waitForGeoCountry(callback, maxAttempts, interval) {
        maxAttempts = maxAttempts || 50;
        interval = interval || 100;
        var attempts = 0;
        
        function check() {
          attempts++;
          if (window.__saGeoCountry) {
            callback();
            return;
          }
          if (attempts >= maxAttempts) {
            return;
          }
          setTimeout(check, interval);
        }
        check();
      }
      
      function loadWidget() {
        // Check if script is already in head
        const existingScript = document.querySelector('script[data-sellabroad-widget]');
        if (existingScript) {
          // Script already loaded, reinitialize all widgets
          scopeReinitializeTo(modalContent);
          return;
        }
        
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.setAttribute('data-sellabroad-widget', 'true');
        fetch('https://app.sellabroad.com/api/widget', {
          headers: {
            'ngrok-skip-browser-warning': '69420'
          }
        })
        .then(function(response) { return response.text(); })
        .then(function(code) {
          script.textContent = code;
          document.head.appendChild(script);
          // Wait a bit for script to execute, then reinitialize all widgets
          setTimeout(function() {
            scopeReinitializeTo(modalContent);
          }, 500);
        })
        .catch(function(error) {
          console.error('Failed to load SellAbroad widget:', error);
        });
      }
      
      waitForGeoCountry(loadWidget);
    }
  });
}
